<template>
  <div class="flex justify-start mb-6 animate-fade-in">
    <div class="inline-flex items-center gap-2 px-2 py-1 text-sm italic text-nera-muted">
      <span ref="textElement">{{ text }}</span>

      <div v-if="type === 'wave'" class="inline-flex items-center gap-1" v-once>
        <span class="w-1.5 h-1.5 rounded-full bg-nera-accent/70 animate-wave"></span>
        <span class="w-1.5 h-1.5 rounded-full bg-nera-accent/70 animate-wave" style="animation-delay: 0.2s"></span>
        <span class="w-1.5 h-1.5 rounded-full bg-nera-accent/70 animate-wave" style="animation-delay: 0.4s"></span>
      </div>

      <div v-else-if="type === 'pulse'" class="inline-block" v-once>
        <span class="text-xl font-bold text-nera-accent animate-cursor">|</span>
      </div>

      <div
        v-else-if="type === 'shimmer'"
        v-once
        class="w-24 h-1 rounded-sm animate-shimmer bg-[linear-gradient(90deg,var(--color-nera-border)_0%,var(--color-nera-accent)_50%,var(--color-nera-border)_100%)] bg-size-[200%_100%]"
      ></div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue'

const props = defineProps({
  type: {
    type: String,
    default: 'wave',
    validator: (value) => ['wave', 'pulse', 'shimmer'].includes(value)
  },
  text: {
    type: String,
    default: 'NERA is thinking...'
  }
})

const textElement = ref(null)

// Direct DOM write avoids re-rendering and resetting the animation each tick.
watch(() => props.text, (newText) => {
  if (textElement.value) {
    textElement.value.textContent = newText
  }
}, { immediate: true })
</script>
